export const REQUEST_SPECIFIC_OBJECTIVE_FOR_REVIEW = "request_specific_objective_for_review"
export const SAVE_SPECIFIC_OBJECTIVE_FOR_REVIEW = "save_specific_objective_for_review"
export const SPECIFIC_OBJECTIVE_FAILURE_FOR_REVIEW = "specific_objective_failure_for_review"
export const SPECIFIC_OBJECTIVE_UPDATED = "specific_objective_updated"
export const CLEAR_SPECIFIC_OBJECTIVE_STATE = "clear_specific_objective_state"